export const PAGE_TYPES = {
  EVENT_OVERVIEW: 'eventOverview_eventOverview_Entry',
}
